// extracted by mini-css-extract-plugin
export var dropdownButton = "_s-0";
export var fullWidthDropdownButton = "_s-1";
export var icon = "_s-3";
export var iconPlaceholder = "_s-2";
export var menuItemRow = "_s-9";
export var separator = "_s-e";
export var shortcutContainer = "_s-7";
export var shortcutContainerFilled = "_s-8";
export var shortcutIconLg = "_s-6";
export var shortcutIconMd = "_s-5";
export var shortcutIconSm = "_s-4";
export var submenuChevron = "_s-d";
export var submenuDropdown = "_s-a";
export var submenuTriggerRow = "_s-b";
export var submenuTriggerRowOpen = "_s-c";